import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  InfortunioInfoModalStyles, LeftSide, ModalBody, ModalContent, ModalHeader,
  RightSide,
  TextContainer,
  TitleBox,
} from './InvaliditaPermanenteInfortunio.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function InvaliditaPermanenteInfortunio({ setShowModal }) {
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <InfortunioInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon fontSize={34} icon={faTimes} cursor="pointer" onClick={() => closeModal()} />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>
                Qui puoi controllare le informazioni su questa offerta.
              </p>
            </TextContainer>
          </LeftSide>
          <RightSide />
        </ModalHeader>
        <ModalContent>

          <div className="card-extra-information">
            <h4 className="fw-bold">Invalidità permanente da infortunio</h4>
            <h5 className="fw-normal mt-3">Franchigie</h5>
            <p className="mt-2">
              Le franchigie variano in base al tipo di rischio associato all’attività dichiarata.
            </p>
            <p className="mt-3">
              Per le
              {' '}
              <strong className="fw-bold">attività professionali rientranti nel Cluster di Rischio A</strong>
              , la franchigia è:
            </p>

            <ul className="mt-3">
              <li>5% relativa sul rischio professionale,</li>
              <li>5% assoluta sul rischio extraprofessionale,</li>
              <li>10% assoluta sul rischio sportivo.</li>

            </ul>

            <p className="mt-3">
              Per le
              {' '}
              <strong className="fw-bold">attività professionali rientranti nel Cluster di Rischio B</strong>
              , la franchigia è:
            </p>

            <ul className="mt-3">
              <li>5% relativa al 10% sul rischio professionale,</li>
              <li>5% assoluta sul rischio extraprofessionale,</li>
              <li>10% assoluta sul rischio sportivo.</li>

            </ul>

            <p className="mt-3">
              Per le
              {' '}
              <strong className="fw-bold">attività professionali rientranti nel Cluster di Rischio C</strong>
              , la franchigia è:
            </p>

            <ul className="mt-3">
              <li>5% relativa al 15% sul rischio professionale,</li>
              <li>5% assoluta sul rischio extraprofessionale,</li>
              <li>10% assoluta sul rischio sportivo.</li>

            </ul>

            <h4 className="fw-bold mt-3">Diaria da ricovero a seguito di infortunio</h4>

            <p className="mt-3">
              In caso di ricovero dovuto a infortunio, è prevista una
              {' '}
              <strong className="fw-bold">franchigia di 3 notti.</strong>

            </p>
          </div>
        </ModalContent>
      </ModalBody>
    </InfortunioInfoModalStyles>
  );
}

export default InvaliditaPermanenteInfortunio;
